import React from 'react';
// import Spin from 'antd/lib/spin';
import ZakuoRosneftInfo from '../../blocks/PageInfo/ZakuoRosneftInfo';

import style from './RnkimContent.module.scss';
import api from '../../../helpers/api';
import getReferrerFrom from '../../../helpers/lib/getReferrerFrom';

const ZakupRosneftContent = () => {
  // const [loading, setLoading] = React.useState<boolean>(true);

  // const [iframe, setIframe] = React.useState<any>();

  const onReport = async () => {
    await api.sendReport(api.API_ZAKUPKI_ROSNEFT_REPORT_TYPE, {
      ...getReferrerFrom(),
    });
  };

  // React.useEffect(() => {
  //   (async () => {
  //     const formData = new FormData();
  //     formData.append('workspaceId', '1561ffef-733d-4245-9304-967845c84e64');
  //     formData.append('reportId', '9ded7628-667e-4042-86f5-bff5783b4192');
  //     formData.append('role', '');
  //     formData.append('username', '');
  //     await fetch('https://biapi.tektorg.ru/Home/Report', {
  //       headers: {
  //         'Access-Control-Allow-Origin': '*',
  //       },
  //       method: 'POST',
  //       body: formData,
  //     })
  //       .then((response) => response.text())
  //       .then((data) => {
  //         setLoading(false);
  //         setIframe(data);
  //       })
  //       .catch((e) => {
  //         console.log(e);
  //       });
  //   })();
  // }, []);

  return (
    <>
      <div className={style.container}>
        <ZakuoRosneftInfo />
      </div>
      <div className={style.frame}>
        <iframe
          onLoad={onReport}
          width="100%"
          height="100%"
          src="https://pix.tektorg.ru/shared/view/9b9b6e85-950b-44be-a094-c092cdc32da8"
          title="rosneft report"
        />
        {/* {!loading ? (
          <iframe onLoad={onReport} width="100%" height="100%" srcDoc={iframe} title="Visiology" />
        ) : (
          <div className={style.spin}>
            <Spin />
          </div>
        )} */}
      </div>
    </>
  );
};

export default ZakupRosneftContent;
